import axios from 'axios';
import { API_BASE_URL } from '../config';

/**
 * Elimina la carga de un período de un módulo (compras, ventas, boletas, ventas_pos):
 * sus asientos, sus documentos y su estado. En ventas_pos se indica el medio de pago.
 * @returns {Promise<{message: string, data: {documentos: number, asientos: number}}>}
 */
export const eliminarPeriodoCarga = async (modulo, id_company, anio, mes, token, tipo_medio_pago) => {
  const response = await axios.delete(`${API_BASE_URL}/api/cargas/${modulo}/periodo/${anio}/${mes}`, {
    params: { id_company, tipo_medio_pago },
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};
